import { t } from 'ttag';
import classNames from 'classnames';
import { generatePath } from 'react-router-dom';

import { Link } from '@ui/Link';
import { Title } from '@ui/Title';
import {
  memberAsBuyerReviews,
  memberAsSellerReviews,
} from '@urls';
import { useSearchParams } from '@utils/common';

import s from './ProfileReviewsFilter.sss';

type ProfileReviewsFilterProps = {
  username: string;
  className?: string;
  sellerCount?: number | null;
  buyerCount?: number | null;
};

export const ProfileReviewsFilter: React.FC<ProfileReviewsFilterProps> = ({
  username,
  className,
  sellerCount,
  buyerCount,
}) => {
  const [params] = useSearchParams();

  const asSellerUrl = generatePath(memberAsSellerReviews, { username });
  const asBuyerUrl = generatePath(memberAsBuyerReviews, { username });

  return (
    (
      <div className={classNames(s.root, className)}>
        <Title
          className={s.title}
          type="h4"
          bold={false}
        >
          {t`Відгуки`}
        </Title>
        <Link
          className={classNames(s.link, { [s.active]: params.t === 's' })}
          to={asSellerUrl}
        >
          {t`Як про продавця`}
        &nbsp;
          {buyerCount}
        </Link>
        <Link
          className={classNames(s.link, { [s.active]: params.t === 'b' })}
          to={asBuyerUrl}
        >
          {t`Як про покупця`}
        &nbsp;
          {sellerCount}
        </Link>
      </div>
    )
  );
};
